import React from "react";
import { css } from "styled-components";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";

const enum fields {
    boxHeight = "boxHeight",
    borderColor = "borderColor",
    borderWidth = "borderWidth",
    marginTop = "marginTop",
    marginBottom = "marginBottom",
    marginRight= "marginRight",
    marginLeft = "marginLeft",
    paddingTop = "paddingTop",
    paddingBottom = "paddingBottom",
    textAlign = "textAlign"
}

interface Props extends WidgetProps {
    fields: {
        [fields.boxHeight]: string;
        [fields.borderColor]: string;
        [fields.borderWidth]: string;
        [fields.marginTop]: string;
        [fields.marginBottom]: string;
        [fields.marginRight]: string;
        [fields.marginLeft]: string;
        [fields.paddingTop]: string;
        [fields.paddingBottom]: string;
        [fields.textAlign]: string;
    }
}

const CustomBox: React.FC<Props> = ({fields, id}) => {
    const {boxHeight, borderColor, borderWidth, marginTop, marginBottom, marginLeft, marginRight, paddingBottom, paddingTop, textAlign} = fields;

    const wrapperStyles = {
        css: css`
            height: ${boxHeight};
            border: ${borderWidth}px solid ${borderColor};
            margin-top: ${marginTop};
            margin-bottom: ${marginBottom};
            margin-left: ${marginLeft};
            margin-right: ${marginRight};
            padding-bottom: ${paddingBottom};
            padding-top: ${paddingTop};
            text-align: ${textAlign};
        `
    }

    return (
        <StyledWrapper {...wrapperStyles}>
            <Zone contentId={id} zoneName="Content" />
        </StyledWrapper>
    )
}


const widgetModule: WidgetModule = {
    component: CustomBox,
    definition: {
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.textAlign,
                displayName: "Text Algin",
                editorTemplate: "DropDownField",
                options: [
                    { value: 'center' },
                    { value: 'right' },
                    { value: 'left' },
                ],
                defaultValue: ''
            },
            {
                fieldType: "Translatable",
                name: fields.boxHeight,
                editorTemplate: "TextField",
                displayName: "Box Height (%)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.borderColor,
                editorTemplate: "ColorPickerField",
                displayName: "Border Color",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.borderWidth,
                editorTemplate: "TextField",
                displayName: "Border Width (px)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.marginTop,
                editorTemplate: "TextField",
                displayName: "Margin Top (px/%/rem)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.marginBottom,
                editorTemplate: "TextField",
                displayName: "Margin Bottom (px/%/rem)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.marginRight,
                editorTemplate: "TextField",
                displayName: "Margin Right (px/%/rem)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.marginLeft,
                editorTemplate: "TextField",
                displayName: "Margin Left (px/%/rem)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.paddingTop,
                editorTemplate: "TextField",
                displayName: "Padding Top (px/%/rem)",
                defaultValue: "0",
            },
            {
                fieldType: "Translatable",
                name: fields.paddingBottom,
                editorTemplate: "TextField",
                displayName: "Padding Bottom (px/%/rem)",
                defaultValue: "0",
            },
            ],
            group: "Common",
    }
}

export default widgetModule;